import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

import "./index.scss";
import { useWindowSize } from "../../../../hooks/use-device-type";

export interface SvgCompAbroadProps {}

export function SvgCompAbroad(props: SvgCompAbroadProps) {
  const { isMobile } = useWindowSize();
  return (
    <OverlayTrigger
      placement={isMobile ? "top" : "bottom-start"}
      overlay={
        <Popover id="svg-comp-abroad">
          <Popover.Body>
            <h3>核心：筛选和培育</h3>

            <ul>
              <li>筛选重点培育人才</li>
              <li>本地培育和外地引进</li>
            </ul>
          </Popover.Body>
        </Popover>
      }
    >
      <g className="svg-comp-piece">
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill="#fe0000"
          d="M 100.5,378.5 C 138.176,380.091 175.843,381.925 213.5,384C 208.999,386.416 204.666,389.083 200.5,392C 233.702,412.029 269.036,417.029 306.5,407C 315.64,403.846 324.474,400.013 333,395.5C 328.455,421.796 323.622,447.796 318.5,473.5C 338.813,489.15 358.813,505.15 378.5,521.5C 356.371,532.375 333.038,539.541 308.5,543C 221.399,554.073 145.732,530.073 81.5,471C 78.1298,467.965 75.1298,464.632 72.5,461C 71.5,460.333 70.5,460.333 69.5,461C 62.4128,464.961 55.2461,468.794 48,472.5C 48.3737,469.725 49.3737,467.058 51,464.5C 67.7763,435.942 84.2763,407.275 100.5,378.5 Z"
        />

        <text x={190} y={490} fontSize={60} fill="#fff" fontWeight={"bold"}>
          留
        </text>
      </g>
    </OverlayTrigger>
  );
}
